import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import AttorneySection from './components/AttorneySection';
import TestimonialSection from './components/TestimonialSection';
import ServiceAreaSection from './components/ServiceAreaSection';
import ProcessTimeline from './components/ProcessTimeline';
import CaseResultsSection from './components/CaseResultsSection';
import FaqSection from './components/FaqSection';
import ConsultationCTA from './components/ConsultationCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <TrustBar />
      <ServicesSection />
      <WhyChooseSection />
      <AttorneySection />
      <TestimonialSection />
      <ServiceAreaSection />
      <ProcessTimeline />
      <CaseResultsSection />
      <FaqSection />
      <ConsultationCTA />
      <Footer />
    </div>
  );
}